<template lang="pug">
    layout.contentTransparent(fluid)

        // Title
        title-component(
            :title="$t('coupons.list.title')"
            slot="title"
            type="h2"
        )

        template
            v-layout(row wrap justify-space-between)
                v-flex(xs12)
                    div.createButtonWrapper

                        // Create Business button
                        button-component.mx-0.my-0(
                            :action="addCoupon"
                            color="action"
                            large
                        ) {{ isMobile ? $t('coupons.list.createButtonMobile') : $t('coupons.list.createButton') }}

            separator-component.overlay

            v-layout(row wrap)
                v-flex(xs12)

                    // Businesses list (Mobile)
                    v-data-table.c-table(
                        v-if="isMobile"
                        :headers-length="8"
                        :items="coupons"
                        :loading="isLoading"
                        hide-actions
                    )
                        template(
                            v-slot:items="props"
                        )
                            tr(@click="props.expanded = !props.expanded")
                                list-mobile(
                                    :item="props.item"
                                    :expanded="props.expanded"
                                )

                        template(slot="expand" slot-scope="props")
                            tr
                                td(colspan="6")
                                    expand-card(:item="props.item")

                    // Coupons list (Desktop)
                    v-data-table.c-table(
                        v-if="!isMobile"
                        :headers="headers"
                        :items="coupons"
                        :loading="isLoading"
                        hide-actions
                    )

                        template(slot="items" slot-scope="props")
                            list-item(:item="props.item")
</template>

<script>
    import Layout from '../../Layout/Layout';
    import ListItem from './ListItem';
    import ListMobile from './ListItemMobile';
    import ExpandCard from './ExpandCard';
    import Button from '~components/Button';
    import Filter from '~components/Filter';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        components: {
            Layout,
            ListItem,
            ListMobile,
            ExpandCard,
            TitleComponent: Title,
            ButtonComponent: Button,
            FilterComponent: Filter,
            SeparatorComponent: Separator
        },
        data() {
            return {
                headers: this.$t('coupons.tableHeaders')
            };
        },
        computed: {
            ...mapGetters('coupons', ['coupons', 'isLoading']),

            // Check screen resolution
            isMobile() {
                return this.$vuetify.breakpoint.smAndDown;
            }
        },
        created() {
            this.getCoupons();
        },
        methods: {
            ...mapActions('coupons', ['getCoupons']),
            addCoupon() {
                this.$router.push({ name: 'dashboard.coupons.create' });
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'

    .createButtonWrapper
        display: flex
        justify-content: flex-end

    .text-left
        text-align: left

    .ceilText
        display: inline-block

    >>> .actions
        min-width: 90px

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .createButtonWrapper
            .btn
                width: 100%
</style>
